import PropTypes from 'prop-types';
import classNames from 'classnames';

import { getPagePath, trans } from '@spotahome/soyuz/client';
import { Link } from '@spotahome/ui-library';

import './GuaranteesCoverDesktop.scss';

const GuaranteesCoverDesktop = ({ covers, className = '' }) => {
  return (
    <div className={classNames('tenant-guarantees-cover-desktop', className)}>
      {covers.map(({ titleKey, textKey, cta, renderIcon }) => (
        <div key={titleKey} className="tenant-guarantees-cover-desktop__item">
          <div className="tenant-guarantees-cover-desktop__item__content">
            <h3 className="tenant-guarantees-cover-desktop__item__title">
              {trans(titleKey)}
            </h3>
            <p className="tenant-guarantees-cover-desktop__item__text">
              {trans(textKey)}
            </p>
            {cta && (
              <Link alt href={getPagePath(cta.routeId)} bold>
                {trans(cta.textKey)}
              </Link>
            )}
          </div>
          {renderIcon()}
        </div>
      ))}
    </div>
  );
};

GuaranteesCoverDesktop.propTypes = {
  covers: PropTypes.arrayOf(
    PropTypes.shape({
      title: PropTypes.string.isRequired,
      text: PropTypes.string.isRequired,
      renderIcon: PropTypes.func.isRequired
    })
  ).isRequired,
  className: PropTypes.string
};

export default GuaranteesCoverDesktop;
